// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cashier-settings-page__modal-form{margin:16px 0}", "",{"version":3,"sources":["webpack://./src/layouts/cashier-settings-page/modals/dialog.scss"],"names":[],"mappings":"AACE,mCACE,aAAA","sourcesContent":[".cashier-settings-page__modal {\n  &-form {\n    margin: 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
